import React, {useRef, useState } from "react";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import Slider from "react-slick";

export default function HaldiInstagram({haldiInsta}) {
  const sliderRef = useRef(null);
  const [progress, setProgress] = useState(0);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1500,     
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    cssEase: "ease",
    responsive: [
        {
          breakpoint: 991,
          settings: { slidesToShow: 3 },
        },
        {
            breakpoint: 767,
            settings: { slidesToShow: 2 },
        },
        {
            breakpoint: 599,
            settings: { slidesToShow: 1,}
        },
    ],
    beforeChange: (oldIndex, nextIndex) => {
      let totalSlides = 0;
      try {
        totalSlides =
          sliderRef.current &&
          sliderRef.current.innerSlider &&
          sliderRef.current.innerSlider.props &&
          sliderRef.current.innerSlider.props.children
            ? sliderRef.current.innerSlider.props.children.length
            : 0;
      } catch (e) {
        totalSlides = 0;
      }

      if (totalSlides <= 1) {
        setProgress(0);
        return;
      }

      const calc = (nextIndex / (totalSlides - 1)) * 100;
      setProgress(calc);
    },
  };

  const handlePrev = () => sliderRef.current && sliderRef.current.slickPrev();
  const handleNext = () => sliderRef.current && sliderRef.current.slickNext();

  return (
    <>
    <section className="haldipage-insta bodygap">
        <div className="insta-slider">
            <Slider {...settings} ref={sliderRef}>
                {haldiInsta.map((item, index) => (
                <div key={index}>
                    <Link to={"https://www.instagram.com/sonamslabel"} target="_blank" className="instaslider-box">
                        <img src={item.image} className="img-responsive" alt="Instagram" loading="lazy"/>
                        <div>
                            <p>Follow Us On <br/>Instagram</p>
                            <span>@sonamslabel</span>
                        </div>
                    </Link>
                </div>
                ))}
            </Slider>

            <div className="default-arrowleft default-mobilearrow" onClick={handlePrev}><Icons name="arrowLeft" /></div>
            <div className="default-arrowright default-mobilearrow" onClick={handleNext}><Icons name="arrowRight" /></div>
        </div>

        <div className="exclusive-controls">
            <div className="slider-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow={Math.round(progress)} style={{
                backgroundSize: `${progress}% 100%`,
                transition: `background-size ${settings.speed}ms ease`, }}>
                <span className="slider__label sr-only"></span>
            </div>
        </div>
    </section>
    </>
  )
}
